import { Injectable } from '@angular/core';
import { USE_CLOUD_RUN_OPTIMIZER } from '@configs/constants';

/**
 * Single source of truth for whether SYNC optimize requests go to the Cloud Run optimizer.
 *
 * `true` → gateway → Cloud Run (sent as `?useCloudRunSync=true`); `false` → GKE. The value is
 * driven entirely by the `USE_CLOUD_RUN_OPTIMIZER` constant (the per-request UI toggles were
 * removed) — flip that constant to switch every sync-optimize path at once. It must reach EVERY
 * sync-optimize request: optimize-routes, shipment-orders (updateOrdersData), reArrange,
 * express-ways, and service-remove.
 *
 * Kept as a root singleton so the value is reachable from the service layer and from child/dialog
 * components (e.g. packing-list-v2) that have no host-component field.
 */
@Injectable({
  providedIn: 'root'
})
export class CloudRunSyncOptimizerToggleService {
  /** true → route sync optimize through the gateway to Cloud Run; false → GKE. */
  useCloudRunSync = USE_CLOUD_RUN_OPTIMIZER;
}
